"use client";

import { useState, useEffect } from "react";
import { Sparkles, Key } from "lucide-react";
import { CallWorkspace } from "@/components/call/call-workspace";
import { Panel } from "@/components/ui/panel";

export default function Page() {
  const [apiKey, setApiKey] = useState<string | null>(null);
  const [inputKey, setInputKey] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for API key on mount
    const stored = localStorage.getItem("varta_groq_key");
    if (stored) {
      setApiKey(stored);
    }
    setLoading(false);
  }, []);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    if (!inputKey.trim()) return;
    localStorage.setItem("varta_groq_key", inputKey.trim());
    setApiKey(inputKey.trim());
  };

  if (loading) return null;

  if (apiKey) {
    return <CallWorkspace />;
  }

  return (
    <div className="varta-ambient flex min-h-screen items-center justify-center p-4">
      <Panel className="w-full max-w-md p-6 relative overflow-hidden">
        {/* Glow effect */}
        <div className="absolute -top-12 -right-12 size-32 rounded-full bg-primary/20 blur-3xl pointer-events-none" />
        
        <div className="mb-8 flex flex-col items-center gap-3">
          <img src="/logo.png" alt="Varta" className="size-16 rounded-2xl shadow-lg" />
          <div className="text-center">
            <h1 className="text-xl font-bold tracking-tight">Varta Sales Copilot</h1>
            <p className="mt-1 text-sm text-text-tertiary">Real-time AI coaching for Google Meet</p>
          </div>
        </div>

        <form onSubmit={handleSave} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <label htmlFor="apiKey" className="text-xs font-semibold text-text-secondary uppercase tracking-wide">
              Groq API Key
            </label>
            <div className="relative">
              <Key className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-text-tertiary" />
              <input
                id="apiKey"
                type="password"
                value={inputKey}
                onChange={(e) => setInputKey(e.target.value)}
                placeholder="gsk_..."
                className="w-full rounded-xl border border-line bg-card-muted py-2.5 pl-9 pr-3 text-sm outline-none placeholder:text-text-tertiary focus:border-primary transition-colors"
                required
              />
            </div>
            <p className="text-[11px] text-text-tertiary">
              Stored securely in your browser's local storage.
            </p>
          </div>

          <button
            type="submit"
            className="mt-2 flex h-10 w-full items-center justify-center gap-2 rounded-xl bg-primary px-4 text-sm font-semibold text-bg transition-opacity hover:opacity-90"
          >
            Start Coaching
          </button>
        </form>
      </Panel>
    </div>
  );
}
